export default __webpack_public_path__ + "static/media/video.ddb95425.mp4";